import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useUpdateAdminNotesContext} from '../contexts/UpdateAdminNotesContext';
import DataItemTextarea from '../../_common/components/DataItemTextarea';
import styles from './styles.module.scss';

export default function UpdateAdminNotes() {
  const {formik, updateAdminNotes} = useUpdateAdminNotesContext();
  const prefix = 'transfersByAgent-update-admin-notes';

  return (
    <div className={styles.card}>
      <h3>
        <FormattedMessage id={`${prefix}-notes`} defaultMessage="Admin notes"/>
      </h3>
        <DataItemTextarea
          fieldId={'adminNotes'}
          value={formik.values.adminNotes}
          label={<FormattedMessage id={`${prefix}-notes`} defaultMessage="Admin notes"/>}
          customLabelStyle={styles.label}
          customTextareaStyle={styles.textarea}
          minRows={7}
          maxRows={7}
        />
      <div>
        <button
          className={styles.primary}
          onClick={() => updateAdminNotes()}
        >
          <FormattedMessage id={`${prefix}-update`} defaultMessage="Update"/>
        </button>
      </div>
    </div>
  );
}
